module.exports = __webpack_public_path__ + "img/max-logo.06b473e1.png";